var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupQuickCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92281 10.1054V9.13091C3.92281 8.61401 4.12814 8.11828 4.49364 7.75278C4.85914 7.38728 5.35487 7.18195 5.87177 7.18195H9.76969C10.0138 7.18195 10.2531 7.22772 10.4762 7.31453",
    stroke: "#17AC88",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17445 5.20064C8.05998 5.22158 7.94201 5.23252 7.82149 5.23252C6.74511 5.23252 5.87253 4.35994 5.87253 3.28356C5.87253 2.20717 6.74511 1.33459 7.82149 1.33459C8.44902 1.33459 9.00728 1.63117 9.36375 2.09181",
    stroke: "#17AC88",
    strokeWidth: 1.03704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0001 10.0951V9.12067C1.00042 8.68884 1.14415 8.26935 1.40872 7.92806C1.67328 7.58676 2.04371 7.343 2.46182 7.23505",
    stroke: "#17AC88",
    strokeWidth: 1.03704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41138 1.38788C3.99215 1.49522 3.62057 1.73903 3.35522 2.08089C3.08986 2.42274 2.94583 2.84318 2.94583 3.27593C2.94583 3.70869 3.08986 4.12913 3.35522 4.47098C3.62057 4.81284 3.99215 5.05665 4.41138 5.16399",
    stroke: "#17AC88",
    strokeWidth: 1.03704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9163 0.750061L10.6323 0.864499L7.49995 7.12921H10.6323L9.99995 11.5001L14.2806 4.92775L11.1544 5.04096L12.9163 0.750061Z",
    stroke: "#EBB376",
    strokeWidth: 1.04412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupQuickCollect);
export default __webpack_public_path__ + "static/media/group-quick-collect.056f1fd5e8da72ee05d54c07619b7a77.svg";
export { ForwardRef as ReactComponent };